
// ========================== USE_APP_INIT_LOGIC ==========================
   export enum APP_INIT_TYPES {
      START_PAGE = 'startPage',
      COMEBACK_PAGE = 'comebackPage',
      BANK_VERIFICATION_RETURN = 'bankVerificationReturn',
      BASIC_INFO_FORM = 'basicInfoForm',
      KONTOMATIK = 'kontomatik',
   }

   export interface IUseAppLogicReturnModel {
      getAccessToken: () => Promise<number | undefined>
      getAppConfiguration: () => Promise<void>
      getAppConsents: () => Promise<void>
      handleAnalyticsRequests: () => Promise<void>
   }
// ========================================================================